import {Component, OnInit} from '@angular/core';
import {PortosService} from "./portos.service";
import {PortosModel} from "./portos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-portos',
  templateUrl: './portos.component.html'
})
export class PortosComponent extends Components implements OnInit {

  portos: PortosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private portosService: PortosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'portos'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.portosService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.portos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.portos);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(porto) {
    let portos = this.portos;
    let portosService = this.portosService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarPorto')+porto.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(portos);
        }

        let index = portos.indexOf(porto);
        portos.splice(index, 1);

        portosService.apagar(porto.id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              this.portos = portos;
            },
            err => {
              // Revert the view back to its original state
              portos.splice(index, 0, porto);
              this.portos = portos;

              this.func.showErro(err.json());
            });

      });

  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.portosService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.portos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/portos/portos.component.ts